import React from 'react';
import "./pages.css";

const Publications = () => {
  return (
    <div className="center-container">
      <ul className='ul-list'>
        <li>
          <div className="publication">
            <span className="publication-title"> Metastable failures in the wild</span>
            <span className="publication-info">
              <i>L Huang, M Magnusson, AB Muralikrishna, <b>S Estyak</b>, R Isaacs, A Aghayev, ...
              16th USENIX Symposium on Operating Systems Design and Implementation (OSDI … 5 2022)</i>
            </span>
          </div>
        </li>
        <li>
          <div className="publication">
            <span className="publication-title"> Sparse mat: A tale of devising a low-cost directional system for pedestrian counting</span>
            <span className="publication-info">
              TR Toha, <b>S Estyak</b>, TA Khan, T Chakraborty, ABMA Al Islam    
              2017 International Conference on Networking, Systems and Security (NSysS), 21-29
            </span>
          </div>
        </li>
        <li>
          <div className="publication">
            <span className="publication-title"> An approach towards greening the digital display system</span>
            <span className="publication-info">
              <i>TR Toha, AM Ishmam, MH Islam, MA Al Maruf, SS Nandi, A Chakraborty, <b>S Estyak</b>, Md A Al Amin, ABMA Al Islam
              2017 4th International Conference on Networking, Systems and Security (NSysS … 2017)</i>
            </span>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Publications;
